import { render, staticRenderFns } from "./ApiAjax.vue?vue&type=template&id=1c30348f&scoped=true&"
import script from "./ApiAjax.vue?vue&type=script&lang=js&"
export * from "./ApiAjax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c30348f",
  null
  
)

export default component.exports